export const IAP_PRODUCT_ICON_BASE = `${process.env.PUBLIC_URL || ""}/v4/products`;

/** App Store / Play IAP product art (512×512) — Sliding + Jigsaw packs share these files. */
export const IAP_PRODUCT_ICONS = [
    {
        id: "master-pass",
        name: "Master Pass",
        summary: "$19.99 — largest credit pack for Sliding Puzzle Quest and Jigsaw Muse.",
        file: "master-pass.png",
    },
    {
        id: "pro-pack",
        name: "Pro Pack",
        summary: "$9.99 — mid credit pack for Sliding Puzzle Quest and Jigsaw Muse.",
        file: "pro-pack.png",
    },
    {
        id: "pocket-pack",
        name: "Pocket Pack",
        summary: "$4.99 — starter credit pack for Sliding Puzzle Quest and Jigsaw Muse.",
        file: "pocket-pack.png",
    },
    {
        id: "hint-pocket",
        name: "2000 Assistant packet",
        summary: "$1.99 — 2000 assistant coins (Hint Pocket / Jigsaw Muse hints pack).",
        file: "hint-pocket.png",
    },
];
